import {http} from '@/helpers/http-helper';

export const getParameters = () => {
    return new Promise( (resolve, reject) => {
        const url = 'parameters';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getParameter = (code) => {
    return new Promise( (resolve, reject) => {
        const url = 'parameter/' + code;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateParameter = (code, value) => {
    return new Promise( (resolve, reject) => {
        const url = 'parameter/' + code;
        http.post(url, {value: value})
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};